interface OAuthEpicTabProps {
  adminLogin: boolean;
  onAdminLoginChange: (value: boolean) => void;
  dashboardLogin: boolean;
  onDashboardLoginChange: (value: boolean) => void;
  disableInputs: boolean;
}

const OAuthEpicTab = ({
  adminLogin,
  onAdminLoginChange,
  dashboardLogin,
  onDashboardLoginChange,
  disableInputs,
}: OAuthEpicTabProps) => (
  <>
    <h3 className="text-lg font-medium text-gray-900">Epic OAuth</h3>
    <div className="space-y-4">
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={adminLogin}
          onChange={(e) => onAdminLoginChange(e.target.checked)}
          disabled={disableInputs}
          className="rounded border-gray-300"
        />
        <span className="text-sm font-medium text-gray-700">Admin Login</span>
      </label>
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={dashboardLogin}
          onChange={(e) => onDashboardLoginChange(e.target.checked)}
          disabled={disableInputs}
          className="rounded border-gray-300"
        />
        <span className="text-sm font-medium text-gray-700">Dashboard Login</span>
      </label>
    </div>
  </>
);

export default OAuthEpicTab;
